import { useQuery } from '@tanstack/react-query';
import { IGetAllBatchesBody, IGetAllBatches } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetAllBatches = ({
  page,
  fromdate,
  todate,
  driver,
  status,
  limit = 10,
}: IGetAllBatchesBody) =>
  useQuery({
    queryKey: ["get_all_batches", page, fromdate, todate, driver, status, limit],
    queryFn: async (): Promise<IGetAllBatches> => {
      const res = await apiClient.get(ENDPOINTS.BATCHES.GET_ALL, {
        params: {
          page,
          fromDate: fromdate,
          toDate: todate,
          driver,
          limit,
          status,
        },
      });
      return res.data;
    },
    enabled: fromdate && todate ? fromdate <= todate : true,
  });
